import { render } from "./RealTime.vue?vue&type=template&id=0286cbf0&scoped=true"
import script from "./RealTime.vue?vue&type=script&lang=js"
export * from "./RealTime.vue?vue&type=script&lang=js"

import "./RealTime.vue?vue&type=style&index=0&id=0286cbf0&scoped=true&lang=css"

import exportComponent from "/Users/akiowatanabe/work_space/secure_link/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0286cbf0"]])

export default __exports__